<template>
  <section :data-theme="theme"  v-intersection-observer="onIntersectionObserver">
    <div class="hero min-h-screen bg-base-100">
      <div class="hero-content flex-col lg:flex-row-reverse">
        <img :src="imageEmploymentHistory()" class="max-w-sm hidden md:block" />
        <div>
          <h1
            class="text-5xl font-bold mb-4"
           
          >
            Historial laboral
          </h1>
          <div class="h-96 overflow-y-auto" id="content">
            <div v-for="(employ, index) in employments" :key="index">
              <div class="card shadow-xl p-4 m-4 bg-base-100">
                <h2 class="card-title m-2">{{ employ.title }}</h2>
                <div className="badge badge-primary m-2">{{ employ.date }}</div>
                <p class="p-2">{{ employ.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useStore } from "vuex";
import { computed, ref } from "vue";

import { vIntersectionObserver } from "@vueuse/components";

const isVisible = ref(false);

function onIntersectionObserver([{ isIntersecting }]) {
  if (isIntersecting) {
    store.dispatch("setTheme", theme.value);
  }
  isVisible.value = isIntersecting;
}

const theme = ref("dark");
const store = useStore();

const employments = computed(() => store.getters.getAllEmployments);

const imageEmploymentHistory = () => {
  return require(`@/assets/images/employment_history.svg`);
};
</script>

<style >
</style>